export interface OffersPageProps {
  offerId?: string;
  eventId: string;
  onClose: () => void;
  step: OffersStep;
  setOfferId: (offerId: string) => void;
  setOffersStep: (step: OffersStep) => void;
}

export enum OffersStep {
  CREATE_OFFER = 'create_offer',
  OFFERS_LIST = 'offers_list',
  EDIT_OFFER = 'edit_offer',
  OFFER_DETAILS = 'offer_details'
}
